import { SessionStorageHelper, DateHelper, createDate, OpeningHoursService } from "@parksandresorts/core";

class OpeningHoursStore {
  constructor() {
    this.promise = null;
    this.key = "OpeningHoursStore-getAllDates";
  }

  fetchPromiseConcurrencyHandler() {
    if (this.promise) {
      return this.promise;
    }
    return (this.promise = OpeningHoursService.getAllDates().then((response) => {
      const timeStampDate = DateHelper.addMinutes(createDate(), 60);
      SessionStorageHelper.setItem(this.key, response, timeStampDate.getTime());
      this.promise = null;
      return Promise.resolve(response);
    }));
  }

  getAllDates() {
    const sessionStorageCache = SessionStorageHelper.getItem(this.key);
    if (sessionStorageCache) {
      return Promise.resolve(sessionStorageCache);
    }
    return this.fetchPromiseConcurrencyHandler();
  }
}

const singleton = new OpeningHoursStore();
export default singleton;
